module.exports = __webpack_public_path__ + "img/ccm19.c6e31b72.jpg";